import { observer } from "mobx-react-lite"

import { DisplayTokenTableValues } from "@/components/display-token-values"
import { dollarsPrettified, formatPercentage } from "@/domains/library"
import { ILiquidityPool } from "@/domains/pools"

export const PoolBalanceColumn = observer(({ pool, isCompact }: { pool: ILiquidityPool; isCompact: boolean }) => {
  const hasUnstakedTokens = pool.userBalance > 0
  const className = hasUnstakedTokens ? "border-warning-text/25 bg-warning-text/10 border p-2 rounded-md" : ""

  if (isCompact) {
    return (
      <div className={className}>
        <div>
          <span className="text-t100">{dollarsPrettified(pool?.userBalanceValueUSD)}</span>{" "}
          <span className="text-t300">({formatPercentage(pool?.userBalancePercentage, 2)})</span>
        </div>
      </div>
    )
  }

  return (
    <div className={className}>
      <div>
        <span className="text-t100">{dollarsPrettified(pool?.userBalanceValueUSD)}</span>{" "}
        <span className="text-t300">({formatPercentage(pool?.userBalancePercentage, 2)})</span>
      </div>
      <DisplayTokenTableValues tokens={pool.tokens} values={[pool.userBalanceToken0, pool.userBalanceToken1]} />
    </div>
  )
})
